<template>
  <div id="app">
    <router-view />
    <div id="message-box"></div>

    <div id="mloading" class="loading">
      <div class="loading-icon"><span
          class="absolute inset-0 rounded-full border border-cyber-cyan/20"></span><span
          class="absolute inset-2 rounded-full border-t-2 border-cyber-cyan animate-radar"></span><span
          class="absolute inset-[1.35rem] rounded-full bg-cyber-cyan shadow-[0_0_18px_rgba(0,240,255,0.7)]"></span>
      </div>
    </div>
  </div>
</template>

<script>
import accountAPI from "@/apis/system/accountAPI";
import commonFn from "@/commons/commonFunction";
import L from 'leaflet';
import popupUtil from "@/commons/popupUtil";
import scanEngineAPI from "@/apis/bussiness/scanEngineAPI";

export default {
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    const me = this;

    commonFn.initLeaflet(L);
  },
  mounted() {
    const me = this,
      path = location.pathname || '';
    // window._cfn = commonFn;

    if (path.toLowerCase().indexOf('/login') === -1) {
      accountAPI
        .ping()
        .catch(ex => {
          console.error(ex);
        });
    }

    // me.initEnterSameTab();
    commonFn.loadProxyCombo();

    setTimeout(() => {
      // popupUtil.show({}, 'WebsiteTemplateDetail', {});
    }, 1000);

    scanEngineAPI.getCombobox()
      .then(res => {
        window._engines = res || [];
        window._engines.forEach(x => {
          // let name = [x.name];
          // if (x.deploy_info) {
          //   name.push(x.deploy_info);
          // }
          // x.text = name.join(': ');

          x.value = x.id;
          x.text = x.name;
        });
      })
      .catch(ex => {
        console.error(ex);
      })

    try {
      const params = new URLSearchParams(window.location.search);
      const dev = params.get('dev');
      if (dev) {
        commonFn.setLocalStorage('dev', true);
      }
    } catch (ex) {
      console.error(ex);
    }
  },
  methods: {
    /**
     * next control khi ấn Enter
     */
    initEnterSameTab() {
      const me = this;

      return;
      window.addEventListener("keydown", function (e) {
        if (e.which === 13 && !e.shiftKey) {
          let tag = e.target.tagName.toLowerCase();
          if (["button", "a"].indexOf(tag) > -1) {
            return;
          }

          if ("textarea" == tag && e.shiftKey) {
            return;
          }
          //Nếu sự kiện xảy ra ở grid thì không bắt sự kiện ở hàm này nữa. Trong grid đã xử lý.
          //Thêm kiểm tra phải là control nhập liệu trong bođy thì mới bỏ qua
          if (
            e.target.closest(".ms-grid-viewer") &&
            e.target.closest("tbody")
          ) {
            return;
          }
          //ntphong 27/5/2021 - với control có class remain-focus-when-enter thì không focus sang control tiếp theo khi ấn enter
          if (e.target.closest(".remain-focus-when-enter")) {
            return;
          }
          let focusable = me.$ms.commonFn.focusNextControl(e.target);
          if (focusable) {
            e.preventDefault();
          }
        }
      });
    },
  },
};
</script>